export default __webpack_public_path__ + "static/media/translator.dc888b0b.svg";